

export const CHECKOUT_BOOKING = "CHECKOUT_BOOKING";
export const FETCH_BY = "FETCH_BY";
export const FETCH_ALL_BOOKING_PAGE = "FETCH_ALL_PAGE";
export const FETCH_PAGE = "FETCH_PAGE";
export const FETCH_MENU = "FETCH_MENU";
export const FETCH_ALL_POST = 'FETCH_ALL_POST';

export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const FETCH_BY_ITEM = "FETCH_BY_ITEM";
export const FETCH_ALL_ITEM = "FETCH_ALL_ITEM";
export const FETCH_ALL = "FETCH_ALL";
export const FETCH_ALL_PAGE = "FETCH_ALL_PAGE";
export const FETCH_ALL_BOOKING = "FETCH_ALL_BOOKING";
export const FETCH_PROCESS_BOOKING = "FETCH_PROCESS_BOOKING";
export const FETCH_SEND_BOOKING = "FETCH_SEND_BOOKING";
export const FETCH_DONE_BOOKING = "FETCH_DONE_BOOKING";
export const FETCH_BY_BOOKING = "FETCH_BY_BOOKING";
export const FETCH_BY_TRACKING = "FETCH_BY_TRACKING";
export const FETCH_BY_TRX = "FETCH_BY_TRX";
export const FETCH_BY_TRACKING_SELF = "FETCH_BY_TRACKING_SELF";
export const FETCH_BY_TRACKING_CUSTOMER = "FETCH_BY_TRACKING_CUSTOMER";
export const FETCH_BY_TRACKING_MOBILE = "FETCH_BY_TRACKING_MOBILE";
export const FETCH_BY_TRACKING_ANY = "FETCH_BY_TRACKING_ANY";
export const FETCH_BY_SEARCH = 'FETCH_BY_SEARCH';
export const FETCH_POST = 'FETCH_POST';
export const LIKE = 'LIKE';
export const COMMENT = 'COMMENT';
export const END_LOADING = "END_LOADING";
export const START_LOADING = "START_LOADING";
export const FETCH_BY_CREATOR = 'FETCH_BY_CREATOR';

export const CREATE_TRX_RIDE = 'CREATE_TRX_RIDE';
export const UPDATE_TRX_RIDE = 'UPDATE_TRX_RIDE';
export const STATE_NEAREST_DRIVERS = 'STATE_NEAREST_DRIVERS';
export const STATE_ORDER_DRIVER_PICKUP = 'STATE_ORDER_DRIVER_PICKUP';
export const STATE_LOCATIONN = 'STATE_LOCATIONN';
export const STATE_COORDINATE_CUSTOMER = 'STATE_COORDINATE_CUSTOMER';
export const STATE_COORDINATE_DRIVER = 'STATE_COORDINATE_DRIVER';


export const CREATE_MESSAGE = 'CREATE_MESSAGE';
export const FETCH_MESSAGE = 'FETCH_MESSAGE';
export const FETCH_MESSAGE_BY = 'FETCH_MESSAGE_BY';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const STATE_LOCATION = "STATE_LOCATION";
export const STATE_ORDER_DRIVER = "STATE_ORDER_DRIVER";

export const ADD_CART = "ADD_CART";
export const ADD_CHECKOUT = "ADD_CHECKOUT";
export const UPDATE_CART = "UPDATE_CART";
export const REMOVE_CART = "REMOVE_CART";
export const CLEAR_CART = "CLEAR_CART";


export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_BY_ROLE = 'FETCH_USER_BY_ROLE';
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_GIT = 'FETCH_USERS_GIT';
export const FETCH_POSTS_GIT = 'FETCH_POSTS_GIT';
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";


export const MAP_LOCATIONS = "MAP_LOCATIONS";
export const NEAREST_DRIVERS = "NEAREST_DRIVERS";
export const CALCULATE_DISTANCE = "CALCULATE_DISTANCE";
export const GET_ORDER_RIDE = "GET_ORDER_RIDE";
export const SET_COORDINATE_START = "SET_COORDINATE_START";
export const SET_COMBINED_MAP_LOCATIONS = "SET_COMBINED_MAP_LOCATIONS";
export const SET_ID_ORDERED_RIDE = "SET_ID_ORDERED_RIDE";
export const DEL_ID_ORDERED_RIDE = "DEL_ID_ORDERED_RIDE";
export const SET_STATUS_ORDERED_RIDE = "SET_STATUS_ORDERED_RIDE";
export const DEL_STATUS_ORDERED_RIDE = "DEL_STATUS_ORDERED_RIDE";


export const FETCHING_API = "FETCHING_API";
